import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { VerticalCard } from "@/components/VerticalCard";
import { getVerticals } from "@/lib/api";
import { toast } from "sonner";

export default function VerticalsPage() {
  const [verticals, setVerticals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVerticals = async () => {
      try {
        const res = await getVerticals();
        setVerticals(res.data);
      } catch (error) {
        toast.error("Failed to load industries");
      } finally {
        setLoading(false);
      }
    };
    fetchVerticals();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="verticals-page">
      <SEOHead
        title="Industry Solutions - ERP for 19+ Verticals"
        description="Explore Absolin's ERP and digital transformation solutions across 21+ industries: Manufacturing, Retail, FMCG, Pharma, Textile, Construction, Energy & Utilities, Defence & Aerospace, and more. Odoo ERP & Focus X ERP experts."
        keywords="industry ERP solutions, manufacturing ERP India, retail ERP, FMCG ERP software, Odoo ERP verticals, Focus X ERP industries, custom ERP development"
        canonicalUrl="/verticals"
        breadcrumbs={[{ name: "Home", url: "/" }, { name: "Industries" }]}
      />
      <Navbar />
      
      <div className="pt-20 md:pt-24">
        {/* Header */}
        <section className="py-12 md:py-16 bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
                Industry <span className="text-[#0066CC]">Solutions</span>
              </h1>
              <p className="text-lg text-slate-600">
                Explore our proven digital transformation solutions across {verticals.length || 14} business verticals. 
                Click on any industry to discover specific challenges and how we solve them.
              </p>
            </div>
          </div>
        </section>

        {/* Verticals Grid */}
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {loading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <div key={i} className="h-80 rounded-2xl bg-slate-100 animate-pulse" />
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 stagger-children">
                {verticals.map((vertical) => (
                  <VerticalCard key={vertical.id} vertical={vertical} />
                ))}
              </div>
            )}

            {!loading && verticals.length === 0 && (
              <div className="text-center py-16">
                <p className="text-slate-500 text-lg">No industries found. Please check back later.</p>
              </div>
            )}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
